import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/one/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"
import AssessmentPage from "../../components/one/AssessmentPage"

const assessment = () => (
  <Layout>
    <SEO title={PAGE.title.assessment} siteTitle="one" />
    <HeadingL title={PAGE.title.assessment} target="one" />
    <AssessmentPage />
  </Layout>
)

export default assessment
